export const visibilityOptions = {
  ANY: 'any',
} as const

export const publisherOptions = {
  ALL: 'all',
  FIRM: 'firm',
  SILVERFIN: 'silverfin',
  PARTNER: 'partner',
} as const

export const sortOptions = {
  DEFAULT: 'default',
  ALPHABETICALLY: 'alphabetically',
  LAST_VISITED: 'last_visited',
  DATE_ADDED: 'date_added',
} as const

export const segmentGroupKeys = {
  PINNED: 'pinned',
  RECOMMENDED: 'recommended',
  CUSTOM: 'custom',
} as const
